import { toast } from '@pcrm/fe/ui-kit';
import { useMutation } from '@tanstack/react-query';
import { ApiError } from '../../lib/api';
import { formatDateTime } from '../../lib/format';
import { fetchSigningLink } from './signing.api';

/** Cât stă pe ecran linkul care n-a putut fi copiat: destul cât să fie selectat cu mâna. */
const MANUAL_COPY_MS = 60_000;

/**
 * „Copiază linkul" — de pe rândul documentului, în tabul „Documente" al clientului și în
 * registrul „Documente emise". Primește **id-ul documentului**: semnarea e 1:1 cu actul.
 *
 * Linkul se cere **la apăsare**, nu la deschiderea ecranului: fiecare cerere lasă un rând
 * în jurnal, iar o încărcare de fundal ar fi scris rânduri pe care nu le-a cerut nimeni.
 *
 * ⚠️ **Clipboard-ul poate lipsi, și atunci butonul n-are voie să tacă.**
 * `navigator.clipboard` există doar în context sigur: `localhost` și `https` da, dar CRM-ul
 * deschis pe IP-ul din rețea, pe `http`, nu — exact configurația în care cineva probează de
 * pe telefon. Fără ramura a doua, operatorul ar apăsa, ar vedea „gata" și ar lipi în
 * WhatsApp ce avea dinainte în clipboard.
 */
export function useCopySigningLink() {
  return useMutation({
    mutationFn: fetchSigningLink,
    onSuccess: async (link) => {
      const expires = `Expiră ${formatDateTime(link.expiresAt)}.`;

      try {
        await navigator.clipboard.writeText(link.url);
        toast.success('Linkul e în clipboard.', { description: expires });
      } catch {
        toast.info('Copiază linkul cu mâna.', {
          description: `${link.url} · ${expires}`,
          duration: MANUAL_COPY_MS,
        });
      }
    },
    onError: (error: unknown) => {
      toast.error(error instanceof ApiError ? error.message : 'Linkul nu a putut fi citit.');
    },
  });
}
